import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import SideMenu from "../Components/SideMenu";
import { useLocation } from "react-router-dom";

const CompensationProposalDetail = () => {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const [initialVillages, setInitialVillages] = useState([]);

  // const compensationId = location.state?.compensationId; // Get ID from state
  // const { beneficiary = {} } = location.state || {};

  // const { beneficiary, compensationId } = location.state || {};
  const { beneficiary, compensationId } = location.state || {};
  // const compensationId = beneficiary?.CompensationId;
  const [compensationDetails, setCompensationDetails] = useState(null);
  console.log("compensationId", compensationId);

  // const fetchCompensationBeneficaiaryDetails = async () => {
  //   debugger
  //   if (!compensationId) return;
  //   try {
  //     const response = await fetch(
  //       `https://backurrda.sarmar.co.in/api/Beneficiary/GetBeneficiaryCompensationDetails1?compensationId=${compensationId}`
  //     );
  //     if (response.ok) {
  //       const data = await response.json();
  //       setCompensationDetails(data); // Update state with fetched data
  //       console.log(data);
  //     } else {
  //       console.error("Failed to fetch details. HTTP Status:", response.status);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching details:", error);
  //   }
  // };

  const fetchCompensationBeneficaiaryDetails = async () => {
    // if (!compensationId) return;
    try {
      // const compensationId = "199"; // Replace with dynamic value if needed
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/Beneficiary/GetBeneficiaryCompensationDetails1?compensationId=${compensationId}`
      );

      if (response.ok) {
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setCompensationDetails(data); // Use full data array for state
          console.log("Fetched Data:", data);
        } else {
          console.warn("No data available for the given compensation ID.");
        }
      } else {
        console.error("Failed to fetch details. HTTP Status:", response.status);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };

  const fetchInitialVillages = async () => {
    debugger;
    try {
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/DetailsInsert/CompensationVillageDetailsGet?compensationId=${compensationId}`
      );
      if (response.ok) {
        const data = await response.json();
        // setInitialVillages(data); // Update state with fetched data
        if (Array.isArray(data)) {
          setInitialVillages(data); // Only set it if it's an array
        } else {
          console.error("Expected an array but got:", data);
        }
        console.log("initialVillages", initialVillages);
      } else {
        console.error(
          "Failed to fetch villages. HTTP Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
    }
  };

  useEffect(() => {
    fetchCompensationBeneficaiaryDetails();
    fetchInitialVillages();
  }, [compensationId]);
  useEffect(() => {
    console.log("Compensation Details:", compensationDetails);
  }, [compensationDetails]);

  // if (!compensationDetails) {
  //   return <div>Loading...</div>;
  // }

  const getFileUrl = (filePath) => {
    if (!filePath) return null; // Return null if the file path is empty
    const fileName = filePath.split("\\").pop(); // Extract file name
    return `https://backurrda.sarmar.co.in/api/Files/view/${fileName}`;
  };
  return (
    <div className="flex flex-col min-h-screen">
      <div className="px-4">
        <Header />
      </div>
      <div className="flex flex-1 ">
        <SideMenu className="hidden lg:block w-1/4 bg-gray-200" />
        {currentStep === 0 && (
          <>
            <div className="flex-1 px-6 py-4 h-full max-h-[calc(100vh-80px)] overflow-y-auto">
              <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
                <h1>Compensation Proposal Details</h1>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Road Details Section */}
                <div className="w-full">
                  <h2 className="text-[#241C68] underline mb-6 mt-6 md:mb-10 md:mt-10">
                    &#x25CF; Road Details
                  </h2>
                  <div className="grid grid-cols-[1fr_auto_1fr] gap-y-4 items-start text-sm md:text-base">
                    <strong>District</strong> <span>:</span>
                    <span className="ml-2">
                      {beneficiary.DistrictNameHindi}
                    </span>
                    <strong>Tehsil</strong> <span>:</span>
                    <span className="ml-2">{beneficiary.TehsilNameHindi}</span>
                    <strong>Block</strong> <span>:</span>
                    <span className="ml-2">{beneficiary.BlockName}</span>
                    <strong>Package No.</strong> <span>:</span>
                    <span className="ml-2">{beneficiary.PackageNo}</span>
                    <strong>Road Name</strong> <span>:</span>
                    <span className="ml-2">{beneficiary.RoadName}</span>
                    <strong>Road Length</strong> <span>:</span>
                    <span className="ml-2">{beneficiary.RaodLengthKM} KM</span>
                    <strong>Road Status</strong> <span>:</span>
                    <span className="ml-2">{beneficiary.RoadStatus}</span>
                    <strong>Sanctioned Amount</strong> <span>:</span>
                    <span className="ml-2">
                      ₹ {beneficiary.SanctionedAmount} lakhs
                    </span>
                    <strong>Sanctioned Date</strong> <span>:</span>
                    <span className="ml-2">
                      {new Date(
                        beneficiary.SanctionedDate
                      ).toLocaleDateString()}
                    </span>
                    <strong>Verified by Revenue</strong> <span>:</span>
                    <span className="ml-2">
                      {beneficiary.VerifiedByRevenue}
                    </span>
                  </div>
                </div>

                {/* Documents Section */}
                <div className="w-full">
                  <h2 className="text-[#241C68] underline mb-6 mt-6 md:mb-10 md:mt-10">
                    &#x25CF; Documents
                  </h2>
                  <div className="grid grid-cols-[1fr_auto_1fr] gap-y-4 items-start text-sm md:text-base">
                    <strong>Revenue Report</strong> <span>:</span>
                    <a
                      href={getFileUrl(beneficiary.RevenueReport)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#117FE5] underline ml-2"
                    >
                      View
                    </a>
                    <strong>GOI Sanctioned Letter</strong> <span>:</span>
                    <a
                      href={getFileUrl(beneficiary.GOISanctionedLetter)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#117FE5] underline ml-2"
                    >
                      View
                    </a>
                    <strong>GOU Sanctioned Letter</strong> <span>:</span>
                    <a
                      href={getFileUrl(beneficiary.GOUSanctionedLetter)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#117FE5] underline ml-2"
                    >
                      View
                    </a>
                    <strong>Road Map</strong> <span>:</span>
                    <a
                      href={getFileUrl(beneficiary.RoadMap)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#117FE5] underline ml-2"
                    >
                      View
                    </a>
                    <strong>Bar Chart</strong> <span>:</span>
                    <a
                      href={getFileUrl(beneficiary.BarChart)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#117FE5] underline ml-2"
                    >
                      View
                    </a>

                    <strong>Road Report</strong> <span>:</span>
                    <a
                     href={`https://reporturrda.sarmar.co.in/Report/MyReport.aspx?CompensationId=${compensationId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#117FE5] underline ml-2"
                    >
                      View
                    </a>

                    <strong>Beneficiary Details Report</strong> <span>:</span>
                    <a
                      href={`https://reporturrda.sarmar.co.in/Report/MyReport2.aspx?CompensationId=${compensationId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#117FE5] underline ml-2"
                    >
                      View
                    </a>



              
                    {/* <div>
                      <h3 className="font-semibold">Village Documents</h3>
                    {initialVillages.map((village, index) => (
                      <div key={index}>
                        <h3 className="font-bold mt-4"> {index + 1} {village.VillageNameHindi}</h3>
                        <div className="grid grid-cols-[1fr_auto_1fr] gap-y-4 items-start text-sm md:text-base">
                          {village.Shajra && (
                            <div>
                              <strong>Village Shajra</strong> <span>:</span>
                              <a
                                href={getFileUrl(village.Shajra)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#117FE5] underline ml-2"
                              >
                                View
                              </a>
                            </div>
                          )}
                          {village.Consent && (
                            <div>
                              <strong>Village Consent</strong> <span>:</span>
                              <a
                                href={getFileUrl(village.Consent)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#117FE5] underline ml-2"
                              >
                                View
                              </a>
                            </div>
                          )}
                          {village.VillageRateList && (
                            <div>
                              <strong>Village Rate List</strong> <span>:</span>
                              <a
                                href={getFileUrl(village.VillageRateList)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#117FE5] underline ml-2"
                              >
                                View
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                    </div> */}
                    <div>
                      <h3 className="font-semibold">Village Documents</h3>
                      {initialVillages.map((village, index) => (
                        <div key={index}>
                          <h3 className="font-bold mt-4 mb-2">
                            {index + 1}. {village.VillageNameHindi}
                          </h3>
                          <div className="grid grid-cols-[1fr_auto] gap-y-4 items-start text-sm md:text-base">
                            {village.Shajra && (
                              <div className="flex items-center">
                                <strong>Village Shajra</strong>{" "}
                                <span className="mx-6">:</span>
                                <a
                                  href={getFileUrl(village.Shajra)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-[#117FE5] underline -ml-2"
                                >
                                  View
                                </a>
                              </div>
                            )}
                            {village.Consent && (
                              <div className="flex items-center">
                                <strong>Village Consent</strong>{" "}
                                <span className="mx-2">:</span>
                                <a
                                  href={getFileUrl(village.Consent)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-[#117FE5] underline ml-2"
                                >
                                  View
                                </a>
                              </div>
                            )}
                            {village.VillageRateList && (
                              <div className="flex items-center">
                                <strong>Village Rate List</strong>{" "}
                                <span className="mx-2">:</span>
                                <a
                                  href={getFileUrl(village.VillageRateList)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-[#117FE5] underline ml-2"
                                >
                                  View
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 md:px-6 lg:px-10">
                <h2 className="text-[#241C68] underline mb-6 mt-6 text-lg md:text-xl lg:text-2xl">
                  &#x25CF; Beneficiaries
                </h2>

                <section className="mt-6">
                  <table className="w-full border-collapse text-center">
                    <thead>
                      <tr className="border-b-2">
                        <th className="p-2 text-sm md:text-base lg:text-lg text-[#929292]">
                          S. No.
                        </th>
                        {/* <th className="p-2 text-sm md:text-base lg:text-lg text-[#929292]">
                      Beneficiary Type
                    </th> */}
                        <th className="p-2 text-sm md:text-base lg:text-lg text-[#929292]">
                          Beneficiary Name
                        </th>
                        <th className="p-2 text-sm md:text-base lg:text-lg text-[#929292]">
                          Contact No.
                        </th>
                        <th className="p-2 text-sm md:text-base lg:text-lg text-[#929292]">
                          Village
                        </th>
                        <th className="p-2 text-sm md:text-base lg:text-lg text-[#929292]">
                          Compensation Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {compensationDetails && compensationDetails.length > 0 ? (
                        compensationDetails.map((detail, index) => (
                          <tr key={index}>
                            <td className="p-2">
                              <input
                                className="border-0 w-full text-center text-sm md:text-base rounded-md p-1"
                                type="text"
                                value={index + 1}
                              />
                            </td>
                            <td className="p-2">
                              <input
                                className="border-0 text-center w-full text-sm md:text-base rounded-md p-1"
                                type="text"
                                value={detail.Name || ""}
                                readOnly
                              />
                            </td>
                            <td className="p-2">
                              <input
                                className="border-0 text-center w-full text-sm md:text-base rounded-md p-1"
                                type="text"
                                value={detail.ContactNo || ""}
                                readOnly
                              />
                            </td>
                            <td className="p-2">
                              <input
                                className="border-0 text-center w-full text-sm md:text-base rounded-md p-1"
                                type="text"
                                value={detail.Village_Name_Hindi || ""}
                                readOnly
                              />
                            </td>
                            <td className="p-2">
                              <input
                                className="border-0 text-center w-full text-sm md:text-base rounded-md p-1"
                                type="text"
                                value={detail.CompnesationAmount || ""}
                                readOnly
                              />
                            </td>
                            {/* <td className="p-2">
                      <input
                        className="w-full text-sm md:text-base rounded-md p-1"
                        type="text"
                      />
                    </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center p-4">
                            No data available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CompensationProposalDetail;
